import { render, staticRenderFns } from "./Especies.vue?vue&type=template&id=461b0ba8&scoped=true"
import script from "./Especies.vue?vue&type=script&lang=js"
export * from "./Especies.vue?vue&type=script&lang=js"
import style0 from "./Especies.vue?vue&type=style&index=0&id=461b0ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461b0ba8",
  null
  
)

export default component.exports